import { message } from 'antd';

class TokenManager {
  private token: string | null = null;

  async fetchToken() {
    try {
      let result = await fetch('/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!result.ok) {
        throw new Error(`HTTP error! status: ${result.status}`);
      }

      let data = await result.json();

      // Save the token
      this.token = data.access_token;
    } catch (error) {
      console.error(error);
      message.error('Failed to fetch token');
      throw error;
    }
  }

  /**
   * Get the token.
   *
   * @returns
   */
  async getToken() {
    if (this.token === null) {
      await this.fetchToken();
    }

    return this.token;
  }

  removeToken() {
    this.token = null;
  }
}

export default new TokenManager();
